import { useState } from "react";
import { Icon } from "../Common.jsx";
import { useApp } from "../../store.jsx";

const isLocal = (ip) => ip === "127.0.0.1" || ip === "::1" || ip === "0.0.0.0" || ip === "localhost";

const truncate = (ip) => {
  if (!ip) return "";
  if (ip.length <= 22) return ip;
  return `${ip.slice(0, 10)}…${ip.slice(-8)}`;
};

export default function IpCell({ ip }) {
  const { toast } = useApp();
  const [copied, setCopied] = useState(false);
  if (!ip) {
    return <span style={{ color: "var(--text-muted)", fontSize: 12 }}>—</span>;
  }
  if (isLocal(ip)) {
    return (
      <span className="badge badge-muted" title={ip} style={{ fontSize: 11 }}>local</span>
    );
  }
  const handleCopy = async (e) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(ip);
      setCopied(true);
      toast("IP copied", "success");
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast("Copy failed", "error");
    }
  };
  return (
    <button
      type="button"
      title={`${ip} — click to copy`}
      onClick={handleCopy}
      style={{
        background: "transparent",
        border: "1px dashed var(--border)",
        borderRadius: 6,
        padding: "2px 8px",
        fontFamily: "monospace",
        fontSize: 12,
        color: "var(--text)",
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        cursor: "pointer",
      }}
    >
      {truncate(ip)}
      <Icon name={copied ? "check" : "copy"} size={11} />
    </button>
  );
}
